import { all, fork } from 'redux-saga/effects';

import { accessGroupSaga } from '../components/admin/access-groups/store/sagas';
import { adminAIChatbotSaga } from '../components/admin/ai/chatbot/store';
import { fewShotDocumentsSaga } from '../components/admin/ai/few-shot/store/sagas';
import { adminAIPlaygroundSaga } from '../components/admin/ai/playground/store';
import { adminAIQueriesSaga } from '../components/admin/ai/queries/store';
import { adminAnalyticsSaga } from '../components/admin/analytics/store/sagas';
import { adminAttestationsSaga } from '../components/admin/attestations/store/sagas';
import { calculatorSaga } from '../components/admin/calculator/store/sagas';
import { clientCalculatorSaga } from '../components/admin/client-calculator/store/sagas';
import { clientDatasetsSaga } from '../components/admin/client-datasets/store/sagas';
import { clientRiskToleranceSaga } from '../components/admin/client-risk-tolerance/store/sagas';
import { clientSaga } from '../components/admin/clients/store/sagas';
import { datasetBuilderSaga } from '../components/admin/dataset-builder/store/sagas';
import { documentNameSaga } from '../components/admin/documents/store/sagas';
import { dropdownListSaga } from '../components/admin/dropdown-lists/store/sagas';
import { entitySaga } from '../components/admin/entity/store/sagas';
import { sendNotificationSaga } from '../components/admin/notification/store/sagas';
import { adminOpinionsSaga } from '../components/admin/opinions/store/sagas';
import { adminPlaybookSaga } from '../components/admin/playbook/store/sagas';
import { portfolioAnalyticsSaga } from '../components/admin/portfolio-analytics/store/sagas';
import { riskToleranceSaga } from '../components/admin/risk-tolerance/store/sagas';
import { roleSaga } from '../components/admin/roles/store/sagas';
import { subCounterpartySaga } from '../components/admin/sub-counterparty-types/store/sagas';
import { userSaga } from '../components/admin/users/store/sagas';
import { workflowSaga } from '../components/admin/workflow/store/sagas';
import { annexDefinitionSaga } from '../components/agency-annex/store/sagas';
import { userAttestationsSaga } from '../components/attestations/store/sagas';
import { loginSaga } from '../components/auth/login/store/sagas';
import { notificationSaga } from '../components/auth/notifications/store/sagas';
import { registrationSaga } from '../components/auth/registration/store/sagas';
import { resetPasswordSaga } from '../components/auth/resetPassword/store/sagas';
import { clauseLibrarySaga } from '../components/clause-library/store/sagas';
import { datasetInstanceSaga } from '../components/datasets/instances/store/sagas';
import { documentAnalyticsSaga } from '../components/documents/analytics/store/sagas';
import { chatbotSaga } from '../components/documents/chatbot/store/sagas';
import { pdfSaga } from '../components/documents/document-viewer/store/sagas';
import { myDocumentsSaga } from '../components/documents/my-documents/store/sagas';
import { documentReportingSaga } from '../components/documents/reporting/store/sagas';
import { searchDocumentsSaga } from '../components/documents/search/store/sagas';
import { doraSaga } from '../components/dora/store/sagas';
import { homepageSaga } from '../components/home/store/sagas';
import { opinionAnalyticsSaga } from '../components/opinions/analytics/store/sagas';
import { opinionInstanceSaga } from '../components/opinions/instances/store/sagas';
import { myOpinionsSaga } from '../components/opinions/my-opinions/store/sagas';
import { opinionNettingEngineSaga } from '../components/opinions/netting-engine/store/sagas';
import { opinionReportingSaga } from '../components/opinions/reporting/store/sagas';
import { userPlaybookSaga } from '../components/playbook/store/sagas';
import { systemMaintenanceSaga } from '../components/admin/system-maintenance/store/sagas';

export default function* rootSaga() {
    yield all([
        fork(loginSaga),
        fork(resetPasswordSaga),
        fork(datasetBuilderSaga),
        fork(documentNameSaga),
        fork(datasetInstanceSaga),
        fork(myDocumentsSaga),
        fork(searchDocumentsSaga),
        fork(documentAnalyticsSaga),
        fork(documentReportingSaga),
        fork(entitySaga),
        fork(dropdownListSaga),
        fork(userSaga),
        fork(annexDefinitionSaga),
        fork(myOpinionsSaga),
        fork(opinionReportingSaga),
        fork(opinionInstanceSaga),
        fork(adminAttestationsSaga),
        fork(userAttestationsSaga),
        fork(clientSaga),
        fork(notificationSaga),
        fork(workflowSaga),
        fork(registrationSaga),
        fork(homepageSaga),
        fork(adminPlaybookSaga),
        fork(sendNotificationSaga),
        fork(userPlaybookSaga),
        fork(clauseLibrarySaga),
        fork(riskToleranceSaga),
        fork(opinionAnalyticsSaga),
        fork(adminAnalyticsSaga),
        fork(opinionNettingEngineSaga),
        fork(doraSaga),
        fork(adminOpinionsSaga),
        fork(adminAIQueriesSaga),
        fork(adminAIPlaygroundSaga),
        fork(adminAIChatbotSaga),
        fork(subCounterpartySaga),
        fork(calculatorSaga),
        fork(pdfSaga),
        fork(chatbotSaga),
        fork(clientRiskToleranceSaga),
        fork(clientDatasetsSaga),
        fork(clientCalculatorSaga),
        fork(accessGroupSaga),
        fork(portfolioAnalyticsSaga),
        fork(roleSaga),
        fork(systemMaintenanceSaga),
        fork(fewShotDocumentsSaga)
    ]);
}
